<div class="mt-3">
  <highcharts-chart
    *ngIf="highChartOptions"
    [Highcharts]="highChart"
    [options]="highChartOptions" style="display: block;"></highcharts-chart>
</div>
